import React from "react";
import { Loader, Card, CardSection } from "cxa-components";
import messages from "components/messagesDescription";
import AccountAccordion from "./widgets/AccountAccordion";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const ClaimRHS = props => {
  const data = useSelector(state => state.claimsPP);
  const claimAccounts = props.claimAccounts || data.claimAccounts;
  let selectedAccounts = [];

  const selectedClaimant = data.selectedClaimant || null;
  const selectedClaimantId =
    (selectedClaimant && Number(selectedClaimant.split("|")[1])) || props.query.claimantId;
  const selectedClaimantType =
    (selectedClaimant && selectedClaimant.split("|")[0]) || props.query.claimantType;

  if (selectedClaimantId && selectedClaimantType) {
    const filteredAccounts =
      (data.selectedClaim &&
        claimAccounts.filter(item =>
          data.selectedClaim.accounts.find(x => item.accountName === x)
        )) ||
      claimAccounts;

    selectedAccounts = filteredAccounts.filter(
      acc => acc.memberKey === selectedClaimantId && acc.memberType === selectedClaimantType
    );
    if (selectedAccounts.length === 0) {
      selectedAccounts = filteredAccounts.filter(acc => acc.memberType === "Employee");
    }
  }

  if (data.isFetchingClaimAccounts) {
    return <Loader />;
  } else {
    return (
      <div className="claim-panel-mobile">
        <Card>
          <CardSection>
            <div style={{ textAlign: "center" }}>
              {selectedAccounts && selectedAccounts.length > 0 ? (
                <h3> {props.intl.formatMessage(messages.claims.yourAccountBalance)}</h3>
              ) : (
                <h3> {props.intl.formatMessage(messages.noAccountsDescription)}</h3>
              )}
            </div>
            {(selectedAccounts || []).map(acc => {
              return (
                <AccountAccordion key={acc.accountName} data={acc} {...props}></AccountAccordion>
              );
            })}
          </CardSection>
        </Card>
        <Card>
          <div style={{ textAlign: "center" }}>
            <h3>{props.intl.formatMessage(messages.claims.pointsToConsider)}</h3>
          </div>
          <CardSection>
            {data.claimItem && (
              <div
                style={{ textAlign: "left" }}
                dangerouslySetInnerHTML={{
                  __html: props.intl.formatMessage({
                    id: data.claimItem.claimInstruction,
                    defaultMessage: data.claimItem.claimInstruction,
                  }),
                }}
              />
            )}
          </CardSection>
        </Card>
      </div>
    );
  }
};

ClaimRHS.propTypes = {
  intl: PropTypes.object,
  claimAccounts: PropTypes.array,
  query: PropTypes.shape({
    claimantId: PropTypes.string,
    claimantType: PropTypes.string,
  }),
};

export default ClaimRHS;



// WEBPACK FOOTER //
// ./components/claim/ClaimRHS.js